// 纵向基础柱状图
import { Axis, Tooltip, Grid, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption2 = {
  styleId:2,
  pluginName: ["formaterControlLenPlugin"],
  // 是否显示柱图折线转化
  isBarToLine: true,
  refreshTime: 90000, //间隔刷新时间
  tooltip: new Tooltip("axis", {
    extraCssText: "border-radius: 10px;",
    show: true,
    trigger: "axis",
    axisPointer: { type: "shadow" },
    borderWidth: 0,
    textStyle: { fontSize: 14, fontWeight: "400", color: "rgba(255, 255, 255, 1)" },
    backgroundColor: "rgba(10, 0, 0, 0.64)",
    showContent: true
  }),
  grid: new Grid(69, 36, 27, 70, { edgeType: "single" }),
  legend: new Legend({
    padding: [0, 0, 10, 0],
    itemGap: 45,
    formatter: "{a|{name}}",
    itemHeight: 10,
    icon: "roundRect",
    borderRadius: [5, 5, 5, 5],
    top: "bottom",
    left: "center",
    itemWidth: 20,
    data: ["有效阅读量", "阅读人数"],
    textStyle: { rich: {}, fontSize: 14, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
  }),
  xAxis: new Axis("category", {
    axisLine: { lineStyle: { color: "rgba(0, 0, 0, 0.24)" } },
    splitLine: { show: true },
    data: [
      { value: "周一", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "周二", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "周三", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "周四", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "周五", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "周六", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } },
      { value: "周日", textStyle: { verticalAlign: "middle", padding: [0, 0, 0, 0], align: "center" } }
    ],
    axisLabel: {
      interval: 1,
      fontSize: 14,
      color: "rgba(0, 0, 0, 0.8)",
      axisLabelLen: 10,
      axisLabelLenControl: false,
      formatter: { _custom: { type: "function", display: "<span>ƒ</span> (value, index)" } }
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: "rgba(0, 0, 0, 0.24)"
      },
      alignWithLabel: false
    }
  }),
  yAxis: new Axis("value", {
    axisLabel: {
      fontSize: 14,
      color: "rgba(0, 0, 0, 0.8)"
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "rgba(0, 0, 0, 0.24)"
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: "rgba(0, 0, 0, 0.24)",
        type: "dashed"
      }
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: "rgba(0, 0, 0, 0.24)"
      }
    }
  }),
  animationEasing: "bounceOut",
  animationDuration: 2000,
  animationEasingUpdate: "bounceOut",
  animationDurationUpdate: 2000,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "rectangular" //直角坐标系
  },
  series: [
    {
      label: {
        formatter: "{c}{valueUnit|}",
        position: "top",
        show: false,
        rich: {
          valueUnit: { fontSize: 14, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
        },
        fontSize: 14,
        fontWeight: "400",

        color: "rgba(0, 0, 0, 0.8)",
        rotate: 0
      },
      formatter: "{value}{valueUnit|人次",
      name: "有效阅读量",
      showBackground: false,
      backgroundStyle: { color: "rgba(0,0,0,.4)" },
      barWidth: "15",
      type: "bar",
      colorBy: "series",
      itemStyle: {
        borderRadius: 1,
        color: {
          colorStops: [
            { offset: 0, color: "rgba(74, 222, 255, 1)" },
            { offset: 1, color: "rgba(94, 109, 255, 1)" }
          ],
          x: 0,
          y: 0,
          y2: 1,
          x2: 0,
          type: "linear"
        }
      },
      data: [
        { value: "600", itemStyle: {} },
        { value: "480", itemStyle: {} },
        { value: "720", itemStyle: {} },
        { value: "890", itemStyle: {} },
        { value: "1000", itemStyle: {} },
        { value: "950", itemStyle: {} },
        { value: "470", itemStyle: {} }
      ],
      animationDelay: { _custom: { type: "function", display: "<span>ƒ</span> (t)" } }
    },
    {
      label: {
        formatter: "{c}{valueUnit|}",
        position: "top",
        show: false,
        rich: {
          valueUnit: { fontSize: 14, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
        },
        fontSize: 14,
        fontWeight: "400",

        color: "rgba(255, 255, 255, 1)",
        rotate: 0
      },
      formatter: "{value}{valueUnit|人次",
      name: "阅读人数",
      showBackground: false,
      backgroundStyle: { color: "rgba(0,0,0,.4)" },
      barWidth: 15,
      type: "bar",
      colorBy: "series",
      itemStyle: { borderRadius: 1, color: "rgba(0, 71, 255, 1)" },
      data: [
        { value: "432", itemStyle: {} },
        { value: "233", itemStyle: {} },
        { value: "344", itemStyle: {} },
        { value: "456", itemStyle: {} },
        { value: "456", itemStyle: {} },
        { value: "654", itemStyle: {} },
        { value: "345", itemStyle: {} }
      ]
    }
  ],
  dataZoomSet: {
    dataLengthAuto: "all"
  }
}
